(function () {
    'use strict';

    angular
        .module('elogbooks.admin.sitegroups')
        .controller('SiteGroupSitesEditController', SiteGroupSitesEditController);

    SiteGroupSitesEditController.$inject = ['$state', '$stateParams', 'messenger', 'apiClient', 'lodash', 'siteGroupResponse', 'siteCollectionResponse', 'selectedSiteCollectionResponse'];

    function SiteGroupSitesEditController ($state, $stateParams, messenger, apiClient, lodash, siteGroupResponse, siteCollectionResponse, selectedSiteCollectionResponse ) {
        var vm = this;
        vm.siteGroup = siteGroupResponse;

        vm.siteSelect = {
            response: siteCollectionResponse,
            link: siteCollectionResponse ? siteCollectionResponse.getLink('self') : null,
            responseKeyPath: 'sites',
            selectedItems: [],
        };

        vm.selectedSites = selectedSiteCollectionResponse.sites;

        if(vm.selectedSites) {
            angular.forEach(vm.selectedSites, function(site) {
                vm.siteSelect.selectedItems.push({href: site.getLink('self'), value: site.name});
            });
        }
        vm.update = updateAction;

        function updateAction() {
            var data = {
                _links: {}
            };

            if (vm.siteSelect.selectedItems.length) {
                data._links.site = vm.siteSelect.selectedItems;
            }

            apiClient.create(vm.siteGroup.getLink('sites'), data).then(function (response) {
                if (response) {
                    $state.go('^', $stateParams, { reload: true }).then(function () {
                        messenger.success('SITE_GROUP_UPDATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }
    }

})();
